// features/paymentSlice.js
import { createAsyncThunk } from '@reduxjs/toolkit'
const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api`
const API_VERSION = 'v1'

export const createStripeCheckoutSession = createAsyncThunk(
	'payment/createCheckoutSession',
	async (data) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/${API_VERSION}/payment/create-checkout-session`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					credentials: 'include',
					body: JSON.stringify(data),
				}
			)

			const result = await res.json()

			if (!res.ok) throw new Error(result.message || 'Checkout failed')

			return { sessionId: result.id }
		} catch (err) {
			console.log(err.message)
		}
	}
)
